// src/pages/Contact.js
import CmsPage from "../components/pages/CmsPage";

export default function Contact() {
  return (
    <CmsPage
      slug="contact"
      fallbackTitle="Contact"
      fallbackContent=""
    />
  );
}
